<nav class="console_menu">
    <ul class="list-unstyled menu_items">
        <li #dashboardActive="routerLinkActive" [routerLinkActive]="['active']">
            <a href="#" [routerLink]="['/dashboard']" class="d-flex align-items-middle">
                <i class="fa-house fa-solid" aria-hidden="true"></i> <span>Dashboard</span>
            </a>
        </li>
        <li #newsActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.newsRead]">
            <a href="#" [routerLink]="['/news']" class="d-flex align-items-middle">
                <i class="fa-newspaper fa-solid" aria-hidden="true"></i> <span>News</span>
            </a>
        </li>
        <li #managersActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.managerRead, permission.managerWrite]">
            <a href="#" [routerLink]="['/managers']" class="d-flex align-items-middle">
                <i class="fa-crown fa-solid" aria-hidden="true"></i> <span>Gestori</span>
            </a>
        </li>
        <li #partnersActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.memberRead, permission.memberWrite]">
            <a href="#" [routerLink]="['/members']" class="d-flex align-items-middle">
                <i class="fa-user" aria-hidden="true" [class]="{ 'fa-regular': !partnersActive.isActive, 'fa-solid': partnersActive.isActive }"></i> <span>Anagrafica soci</span>
            </a>
        </li>
        <li #myRelativesActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.relativeRead, permission.relativeWrite]">
            <a href="#" [routerLink]="['/my-relatives']" class="d-flex align-items-middle">
                <i class="fa-users fa-solid" aria-hidden="true"></i>
                <span>I miei familiari</span>
            </a>
        </li>
        <li #relativeRequestsActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.relativeAcceptance]">
            <a href="#" [routerLink]="['/relative-requests']" class="d-flex align-items-middle">
                <i class="fa-address-card" aria-hidden="true" [class]="{ 'fa-regular': !relativeRequestsActive.isActive, 'fa-solid': relativeRequestsActive.isActive }"></i>
                <span>Anagrafica familiari</span>
            </a>
        </li>
        <li #newsEditorActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.newsWrite]">
            <a href="#" [routerLink]="['/news-editor']" class="d-flex align-items-middle">
                <i class="fa-newspaper" aria-hidden="true" [class]="{ 'fa-regular': !newsEditorActive.isActive, 'fa-solid': newsEditorActive.isActive }"></i> <span>News</span>
            </a>
        </li>
        <li #requestsManagementActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.requestAcceptance]">
            <a href="#" [routerLink]="['/request-management']" class="d-flex align-items-middle">
                <i class="fa-file" aria-hidden="true" [class]="{ 'fa-regular': !requestsManagementActive.isActive, 'fa-solid': requestsManagementActive.isActive }"></i>
                <span>Richieste</span>
            </a>
        </li>
        <li #myRequestsActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.requestRead, permission.requestWrite]">
            <a href="#" [routerLink]="['/my-requests']" class="d-flex align-items-middle">
                <i class="fa-file" aria-hidden="true" [class]="{ 'fa-regular': !myRequestsActive.isActive, 'fa-solid': myRequestsActive.isActive }"></i>
                <span>Le mie Richieste</span>
            </a>
        </li>
        <li #proceduresActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.proceduresRead, permission.proceduresWrite]">
            <a href="#" [routerLink]="['/procedures']" class="d-flex align-items-middle">
                <i class="fa-money-bill-1" aria-hidden="true" [class]="{ 'fa-regular': !proceduresActive.isActive, 'fa-solid': proceduresActive.isActive }"></i> <span>Prestazioni</span>
            </a>
        </li>
        <li #exportActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.exportExecutor]">
            <a href="#" [routerLink]="['/export']" class="d-flex align-items-middle">
                <i class="fa-file-export fa-solid" aria-hidden="true"></i> <span>Export</span>
            </a>
        </li>
        <li #auditsActive="routerLinkActive" [routerLinkActive]="['active']" *roleRestriction="[permission.auditRead]">
            <a href="#" [routerLink]="['/audits']" class="d-flex align-items-middle">
                <i class="fa-file-lines fa-solid" aria-hidden="true"></i> <span>Audit log</span>
            </a>
        </li>
        <li class="item_bottom">
            <div class="row ps-3 pb-3" *roleRestriction="permission.newsRead">
                <button class="btn p-0 align-items-center d-flex" (click)="profileModal()"><i class="fa-regular fa-user me-3 align-middle"></i><span>Profilo utente</span></button>
            </div>
            <div class="row ps-3">
                <button class="btn p-0 align-items-center d-flex" (click)="logout()"><i class="fa-right-from-bracket fa-solid me-3"></i> <span>Logout</span></button>
            </div>
        </li>
    </ul>
</nav>
